export var MapTheme = {
  light: 'mapbox://styles/zcxduo/ck2ypyb1r3q9o1co1766dex29',
  dark: 'mapbox://styles/zcxduo/ck241p6413s0b1cpayzldv7x7',
  normal: 'mapbox://styles/mapbox/streets-v11',
  blank: {
    version: 8,
    sources: {},
    layers: [{
      id: 'background',
      type: 'background',
      layout: {
        visibility: 'none'
      }
    }]
  }
};
//# sourceMappingURL=theme.js.map